import { CustomAction } from './customAction';
import { BaseModel } from '../models/basemodel';

export class IconAction<T extends BaseModel> extends CustomAction<T> {
  public icon: string;

  public secondaryIcon?: string;

  public className: string;

  constructor(
    text: string,
    icon: string,
    isDelete = false,
    isActive?: (id: string) => boolean,
    secondaryIcon?: string,
    className = 'btn-outline-secondary',
  ) {
    super(text, false, isDelete, isActive);
    this.icon = icon;
    this.secondaryIcon = secondaryIcon;
    this.className = className;
  }
}
